module.exports = __webpack_public_path__ + "static/media/icon-facebook.e6ea33aa.svg";